export default "__VITE_ASSET__BwJ0683a__"